import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from './schema'; // generated by openapi-typescript

// Auth0 instance will be set after app initialization
let auth0Instance: any = null;

export const setAuth0Instance = (instance: any) => {
  auth0Instance = instance;
};

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    // Add Authorization header if auth0 is available
    if (auth0Instance) {
      try {
        const token = await auth0Instance.getAccessTokenSilently();
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      } catch (error) {
        // Silently fail if token retrieval fails (user might not be logged in)
        console.debug('Failed to get access token:', error);
      }
    }
    return request;
  },
};

export const client = createClient<paths>({ baseUrl: import.meta.env.VITE_API_URL });

// Register authentication middleware
client.use(authMiddleware);
